__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "video_conference_0_1_12";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@kne/axios-fetch", "1.2.4", () => (Promise.all([__webpack_require__.e(313), __webpack_require__.e(946)]).then(() => (() => (__webpack_require__(24313))))));
			register("@kne/local-storage", "0.1.2", () => (__webpack_require__.e(837).then(() => (() => (__webpack_require__(27837))))));
			register("@kne/react-fetch", "1.5.7", () => (Promise.all([__webpack_require__.e(46), __webpack_require__.e(446), __webpack_require__.e(240), __webpack_require__.e(884), __webpack_require__.e(563)]).then(() => (() => (__webpack_require__(85240))))));
			register("@kne/remote-loader", "1.5.0", () => (Promise.all([__webpack_require__.e(46), __webpack_require__.e(446), __webpack_require__.e(524), __webpack_require__.e(884), __webpack_require__.e(801)]).then(() => (() => (__webpack_require__(88524))))));
			register("@kne/token-storage", "1.0.0", () => (__webpack_require__.e(463).then(() => (() => (__webpack_require__(36463))))));
			register("@kne/use-ref-callback", "0.1.3", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(695)]).then(() => (() => (__webpack_require__(46695))))));
			register("antd", "6.6.6", () => (Promise.all([__webpack_require__.e(171), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(469), __webpack_require__.e(998)]).then(() => (() => (__webpack_require__(21171))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(632).then(() => (() => (__webpack_require__(11632))))));
			register("dayjs", "1.11.23", () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(96845))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(901), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(25901))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(108), __webpack_require__.e(884), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(86108))))));
			register("react", "18.3.1", () => (__webpack_require__.e(888).then(() => (() => (__webpack_require__(52888))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};